<template>
  <div class="video-box">
    <div class="select">
      <div class="input-left">
        <div style="display: flex;align-items: center;margin-right: 10px"><div style="width: 60px;font-size:14px">名称：</div><div style="width:200px;display:flex;"><el-input size="small" v-model="addForm.videoName" clearable placeholder="请输入视频名称"></el-input></div></div>
   
      <span class="button" @click="doFilter">查询</span>
      </div>
      <div>
        <span class="button" style="margin:0 8px" @click="addRow">添加视频</span>
      <span class="button" @click="configVideo">配置</span>
      </div>
    </div>
    <div class="video">
      <div class="video-item" v-for="item in videoList" :key="item.id">
         <el-radio :label="item.videoId" v-model="checkedVideo" style="position: absolute;top: 14px;left: 14px;z-index: 100;"  @change="handleCheckedCitiesChange(item)">{{''}}</el-radio>
         <div style="height: 26vh;"><video class="video-dom" :src="item.videoUrl" style="width:100%;height:100%;position: relative;background:#000" controls="controls"></video></div>
         <div style="padding: 0 10px;">
            <div style="font-size: 16px;color: #666;text-align: left;margin: 6px 0">{{item.videoName}}</div>
            <div style="display: flex;justify-content: space-between;">
              <p style="font-size: 14px;color: #9E9E9E" class="nowrap">简介：{{item.remark}}</p>
              <p>
                <span class="button2" style="color: #8EA3CE;margin-right: 8px" @click="editFun(item)">编辑</span>
                <span class="button2" style="color: #EC0F0F;border: 1px solid rgba(236, 15, 15, 0.8);" @click="delFun(item)">删除</span>
              </p>
            </div>
         </div>
      </div>
    </div>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[12, 24, 36]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalItems"
    ></el-pagination>
     <!-- 配置视频 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="addFormVisible"
      center
      width="600px"
      :append-to-body="true"
      :lock-scroll="false"
      class="add-form"
    >
      <div slot="title" class="dialog-title">{{dialogTitle}}</div>
      <el-form :model="addForm" label-width="160px" ref="ruleForm" style="padding-top: 16px">
        <el-form-item label="课程名称：" prop="videoName" required>
          <el-input v-model="addForm.videoName" autocomplete="off" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="排序：">
          <el-input v-model="addForm.sort" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="课程简介：">
          <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 10}" v-model="addForm.courseIntroduce" style="width: 300px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbitAddRow('ruleForm')" style="background: #4D6EB1">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 企业下面的项目 -->
    <el-dialog
      title="配置视频类型"
      :visible.sync="proVis"
      center
      width="400px"
      :append-to-body="true"
      :lock-scroll="false"
      class="add-form"
    >
      <div slot="title" class="dialog-title">配置视频类型</div>
      <!-- <div class="dialog-top">
        <span>单位名称：</span><el-input size="small" placeholder="请输入单位名称" style="width: 200px"></el-input> <span class="button">查询</span>
      </div> -->
      <el-tree
        ref="tree"
        style="padding: 24px 38px;"
        :data="dataTree"
        node-key="entId"
        :props="defaultProps"
        show-checkbox
        @check="checkTree"
        >
      </el-tree>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="proVis = false">取 消</el-button>
        <el-button size="medium" type="primary" @click="toProjectFun" style="background: #4D6EB1">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 新增窗口  添加视频 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="addFormVisible1"
      center
      :append-to-body="true"
      :lock-scroll="false"
      class="add-form"
      width="600px"
    >
    <div slot="title" class="dialog-title">{{dialogTitle}}</div>
      <el-form
        style="padding-top: 16px"
        :model="addForm1"
        ref="addForm1"
        label-width="160px"
        :label-position="labelPosition"
        :rules="rules"
      >
        <el-form-item label="名称：" prop="videoName">
          <el-input v-model="addForm1.videoName" autocomplete="off" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="排序：">
          <el-input v-model="addForm1.sort" autocomplete="off" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="简介：">
          <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 10}" v-model="addForm1.remark" autocomplete="off" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="视频：">
          <el-upload
            class="avatar-uploader"
            v-bind:action="uploadUrl"
            v-bind:data="uploadData"
            v-bind:headers="uploadHead"
            v-bind:on-progress="uploadVideoProcess"
            v-bind:on-success="handleVideoSuccess"
            v-bind:before-upload="beforeUploadVideo"
            v-bind:show-file-list="false"
          >
            <video
              v-if="videoForm.showVideoPath !='' && !videoFlag"
              v-bind:src="videoForm.remark"
              class="avatar video-avatar"
              controls="controls"
            >您的浏览器不支持视频播放</video>
            <i
              v-else-if="videoForm.showVideoPath =='' && !videoFlag"
              class="el-icon-plus avatar-uploader-icon"
            ></i>
            <el-progress
              v-if="videoFlag == true"
              type="circle"
              v-bind:percentage="videoUploadPercent"
              style="margin-top:7px;"
            ></el-progress>
          </el-upload>
        </el-form-item>
        <el-form-item label="视频封面">
          <el-upload
            class="avatar-uploader video-avatar"
            v-bind:action="uploadphotoUrl"
            :headers="uploadHead"
            :data="uploadphotoData"
            :show-file-list="false"
            :on-success="handleIconSuccess"
          >
            <img v-if="addForm.videoCover" style="width: 100%" :src="posterView" class="avatar video-avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="cancal()">取 消</el-button>
        <el-button size="medium" type="primary" @click="sumbitAddRow1('addForm1')" style="background: #4D6EB1">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import base from '../../../../untils/base'
  import myHttp from '../../../../untils/port'
  import util from '../../../../untils/util'
  export default {
    data() {
      return {
        entIds: '',
        labelPosition: 'right',
        groupId: '',
        port: '',
        dialogTitle: '', //弹出框名称
        addFormVisible: false,
        addForm: {
          videoGroupId: '',
          videoName: '',
          sort: '',
          courseIntroduce: '',
          business: '',
          videoCover: ''
        },
        dataTree: [],
        defaultProps: {
          children: 'children',
          label: 'entName'
        },
        addForm1: {
          sort: '',
          remark: '',
          videoId: '',
          videoUrl: '',
          videoCover: '',
          videoName: '',
          videoLength: '',
        },
        checkAll: false,
        isIndeterminate: false,
        checkedVideo: null,
        proVis: false, //配置项目弹出框
        selProject: {}, //选中的项目
        projects: [], //企业项目的项目
        diaSearch: {
          projectName: '',
          entId: '',
        },
        currentPage: 1,
        pageSize: 12,
        totalItems: 0,
        videoList: [], //所有视频
        userTypes: [
          { name: '考试视频', id: '1' },
          { name: '通道视频', id: '2' },
        ], //使用类型
        useType:'',
        addFormVisible1:false,
              rules: {
          videoName: [
            { required: true, message: '请输入名称', trigger: 'change' },
          ],
        },
        videoFlag: false,
        //是否显示进度条
        videoUploadPercent: 0,
        //进度条的进度，
        isShowUploadVideo: false,
        //显示上传按钮
        videoForm: {
          showVideoPath: '', //封面地址
        },
        uploadUrl: myHttp.uploadVideo, //视频上传地址
        uploadphotoUrl:base.url+"/upload/uploadPhoto",
        uploadHead: {
          accessToken: util.session.get('token'),
        },
        uploadData: {
          uploadType: '218',
        },
        uploadphotoData: {
          type: '218',
        },
      }
    },
    created() {
      this.groupId = util.session.get('groupId')
      this.getData()
      this.teamTree()
    },

    updated(){
      const video = document.querySelectorAll('.video-dom')
      console.log(video); 
      console.log(video[0].currentTime);
    },

    methods: {
      handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    //获取视频数据
    getData(flag) {
      var that = this
       myHttp.projectExamVideoProjectList({
          projectId: this.groupId,
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          videoName: this.addForm.videoName,
          own:'3'
        }).then(function (resp) {
          console.log(resp)
          if (resp.data.code == '200') {
            var list = resp.data.data.examVideoProjectList.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].videoCover =
                list[i].videoCover && list[i].videoCover != ''
                  ? base.httpCtx + list[i].videoCover
                  : require('../../../../assets/image/v-cover.png')
              list[i].videoUrl =
                list[i].videoUrl && list[i].videoUrl != ''
                  ? base.httpCtx + list[i].videoUrl
                  : ''
            }
            that.videoList = list
            that.totalItems = resp.data.data.examVideoProjectList.total || 0
          }
        })
      // }
    
    },

    //获取树形结构  getProjectEntByProjectId
     teamTree() {
      var that = this
      myHttp.getProjectEntByProjectId({
        projectId: this.groupId
      }).then(function(resp) {
        console.log(resp)
        if (resp.data.code == '200') {
          var list = resp.data.data.projectEnt || []
          // var tree = util.common.listToTree('id', 'parentId', list)
          var obj = [{ entName: '全部', emtId: '', parentId: '', children: [] }]
          // console.log(tree);
          obj[0].children = list
          that.dataTree = obj
          console.log(that.dataTree)
        }
      })
    },
    // teamTree() {
    //   var that = this
    //   myHttp.getEntTeams({
    //     projectId: this.groupId
    //   }).then(function(resp) {
    //     console.log(resp)
    //     if (resp.data.code == '200') {
    //       var list = resp.data.data.list || []
    //       var tree = util.common.listToTree('id', 'parentId', list)
    //       var obj = [{ name: '全部', id: '', parentId: '', children: [] }]
    //       console.log(tree);
    //       obj[0].children = tree
    //       that.dataTree = obj
    //       console.log(that.dataTree)
    //     }
    //   })
    // },

     //展示视频信息弹出框
    editFun(row) {
      // console.log(row)
      this.dialogTitle = '编辑'
      this.addFormVisible = true
      this.addForm.videoGroupId = row.videoGropuId
      this.addForm.videoName = row.videoName
      this.addForm.sort = row.sort
      this.addForm.courseIntroduce = row.courseIntroduce || row.course_introduce
      this.addForm.business = row.business
    },
    //监听图片上传
    handleIconSuccess(res, file) {
      this.icon = URL.createObjectURL(file.raw)
      this.form.icon = res.data.saveUrls
    },
    //提交编辑信息
    sumbitAddRow(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var that = this
          myHttp.editExamVideo(this.addForm).then(function (resp) {
            if (resp.data.code == '200') {
              that.$message.success('编辑成功')
              that.getData()
              that.addFormVisible = false
            } else {
              that.$message.error(resp.data.msg)
            }
          })
        } else {
          return false
        }
      })
    },

    //全选
    handleCheckAllChange(val) {
      var all = []
      for (var i = 0; i < this.videoList.length; i++) {
        all.push(this.videoList[i].videoId)
      }
      this.checkedVideo = val ? all : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange(row) {
      console.log(row)
      this.checkedVideo = row.videoId
    },
    //配置项目
    configVideo() {
        if (!this.checkedVideo) {
        this.$message.error('请选择视频')
        return
      }
      this.selProject = {}
      this.proVis = true
      this.getProject()
    },
    //获取选中的项目
    handleSelectionChange(val) {
      this.selProject = val
    },
    //弹出框查询
    diaFilter() {
      this.getProject()
    },
    //获取项目
    getProject() {
      this.diaSearch.entId = this.groupId
      var that = this
      myHttp.getProEnt(this.diaSearch).then(function (resp) {
        if (resp.data.code == '200') {
          var list = resp.data.data.projectList || []
          that.projects = list
        }
      })
    },

    checkTree(val, allCheck){
      let data = allCheck.checkedNodes
      let entIds = ''
      data.forEach(node => {
        entIds = entIds + ',' + node.emtId
      })
      entIds = entIds.slice(1)
      this.entIds = entIds
    },

    //配置项目
    toProjectFun() {
      var that = this
      var videoIds = this.checkedVideo
      var projectId = this.groupId
      myHttp.setUpProjectVideoNew({
          videoId: videoIds,
          projectId: projectId,
          groupId: this.entIds,
          createBy: util.session.get('user').id
        }).then(function (resp) {
          console.log(resp);
          if (resp.data.code == '200') {
            that.$message.success('操作成功')
            that.proVis = false
            that.selProject = {}
          } else {
            that.$message.error(resp.data.msg)
          }
        })
    },
    //
    getRadioRow(index, row) {},
    // 新增数据
    addRow() {
      this.videoForm.showVideoPath = ''
      this.dialogTitle = '添加视频'
      ;(this.addFormVisible1 = true),
        (this.addForm1 = {
          videoId: '',
          videoUrl: '',
          videoCover: '',
          videoName: '',
          videoLength: '',
        })
    },
    // 将新增的数据添加到表格中
    sumbitAddRow1(formName) {
      var that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
            this.addForm1.createBy = util.session.get('user').id
            this.addForm1.videoUrl = this.videoPath
            this.addForm1.videoLength = this.playTime
            this.addForm1.videoCover = this.poster
            this.addForm1.projectId = this.groupId
            myHttp.uploadProjectVideo(this.addForm1).then(function (resp) {
              if (resp.data.code == '200') {
                that.$message.success('添加成功')
                that.addFormVisible1 = false
                that.currentPage = 1
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
        //上传前回调
    beforeUploadVideo(file) {
      var that = this
      var fileSize = file.size / 1024 / 1024 < 150
      if (
        [
          'video/mp4',
          'video/ogg',
          'video/flv',
          'video/avi',
          'video/wmv',
          'video/rmvb',
          'video/mov',
        ].indexOf(file.type) == -1
      ) {
        that.$message.error('请上传正确的视频格式')
        return false
      }
      if (!fileSize) {
        that.$message.error('视频大小不能超过50MB')
        return false
      }
      this.isShowUploadVideo = false
    },
       //进度条
    uploadVideoProcess(event, file, fileList) {
      this.videoFlag = true
      this.videoUploadPercent = file.percentage.toFixed(0) * 1
    },
    //上传成功回调
    handleVideoSuccess(res, file) {
      console.log(res);
      this.isShowUploadVideo = true
      this.videoFlag = false
      this.videoUploadPercent = 0

      //后台上传地址
      if (res.code == 200) {
        this.videoForm.showVideoPath = base.httpCtx + res.data.videoUrl
        this.poster = res.data.videoCover
        this.addForm.videoCover = res.data.videoCover
        this.posterView =
          base.httpCtx + res.data.videoCover + '?' + 't=' + new Date().getTime()
        this.videoPath = res.data.videoUrl
        this.playTime = res.data.videoLength
        console.log(this.posterView)
        // this.videoId = res.data.id
      } else {
        this.$message.error(res.msg)
      }
    },
    // 上传封面图片成功
    handleIconSuccess(res, file) {      
      if (res.code == '200') {
        this.poster = res.data.saveUrls
        this.addForm.videoCover = res.data.saveUrls
        var time = new Date().getMilliseconds()
        this.posterView = base.httpCtx + res.data.saveUrls + '?' + 't=' + time
      } else {
        this.$message.error(res.msg)
      }
    },
    //
    cancal(){
      this.addFormVisible1 = false
    },
    doFilter(){
      this.getData()
    },
    //删除
    delFun(row){
      console.log(row)
      var that = this
      this.$confirm('此操作将永久删除该视频, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
        myHttp.cancelDistributeVideo({
          videoGroupId: row.videoGropuId
        }).then(function(resp) {
          if (resp.data.code == '200') {
              that.$message.success('删除成功')
              that.getData()
          } else {
              that.$message.error(resp.data.msg)
          }
        })
      }).catch(err => {})
    },
    },
  }
</script>

<style scoped>
.button{
  display: inline-block;
  width: 80px;
  height: 32px;
  border-radius: 6px;
  background: #FDFEFE;
  box-sizing: border-box;
  border: 1px solid #999999;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  text-align: center;
  line-height: 32px;
}
.button:hover{
  background-color: #4D6EB1;
  color: #fff;
}
.button2{
  display: inline-block;
  width: 50px;
  height: 24px;
  border-radius: 4px;
  background: rgba(227, 233, 246, 0.05);
  box-sizing: border-box;
  border: 1px solid rgba(153, 153, 153, 0.8);
  font-size: 14px;
  text-align: center;
  line-height: 24px;
  cursor: pointer;
}
.video-box{
  height: 100%;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.select{
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 18px;
  border-bottom: 2px solid #D8D8D8;
}
.video{
  height: 70vh;
  padding: 16px;
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  overflow: auto;
}
.video-item{
  position: relative;
  width: 32.69%;
  height: 33vh;
  border-radius: 6px;
  box-shadow: 2px 4px 8px 0px rgba(197, 197, 197, 0.3);
  margin-right: 15px;
  margin-bottom: 16px;
}
.video-item >>> .el-radio__inner{
  height: 18px;
  width: 18px;
  border-radius: 0;
}
.video-item:nth-child(3n){
  margin-right: 0;
}
.video-item >>> .el-radio__inner::after{
  width: 0;
  height: 0;
}
.video-item >>> .el-radio__input.is-checked .el-radio__inner{
  background: #4D6EB1;
  border-color: #4D6EB1;
}
.video-item >>> .el-radio__inner{
  width: 20px;
  height: 20px;
  border-radius: 25px;
}
/deep/ .el-dialog__header{
  padding: 11px 24px;
  background: #ECF0F5;
}
.dialog-title{
  font-size: 18px;
  color: #666666;
  text-align: left;
}
/deep/ .el-dialog__close{
  font-size: 20px;
  top: -6px;
}
.dialog-top{
  padding: 8px 16px;
  padding-right: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #ECF0F5;
}
/deep/ .el-dialog__body{
  padding: 0;
}
.input-left{
  display: flex;
  padding: 1vw;
}
.content-box{
  overflow: none;
}
</style>